import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillToolbar, { modules, formats } from "./QuillToolbar";
import { useState } from "react";
// import "./styles.css";

export const TextAreaQuill = ({ value, onChange }) => {
  //   const [state, setState] = useState({ value: null });
  //   const handleChange = (value) => {
  //     setState({ value });
  //   };
  return (
    <div className="text-editor ">
      <QuillToolbar />
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={"Write something..."}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default TextAreaQuill;
